import { useIsClient } from '@/hooks/useIsClient';
import { usePageScroll } from '@lemonade-hq/cdk';
import { clampedInversedLerp } from '@lemonade-hq/ts-helpers';
import dynamic from 'next/dynamic';
import { useState, useEffect } from 'react';
import styled from 'styled-components';

const CatAnimation = dynamic(() => import('./CatAnimation').then(mod => mod.CatAnimation));
const DogAnimation = dynamic(() => import('./DogAnimation').then(mod => mod.DogAnimation));

const FADE_IN_DURATION = 750;

const StyledDogAnimation = styled(DogAnimation)<{ visible: boolean }>`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity ${FADE_IN_DURATION}ms ease-in-out;
`;

const StyledCatAnimation = styled(CatAnimation)<{ visible: boolean }>`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity ${FADE_IN_DURATION}ms ease-in-out;
`;

const ANIMATION_END_SCROLL = 1122;

const PetAnimation = () => {
  const isClient = useIsClient();
  const [visible, setVisible] = useState(false);
  const { absoluteScroll } = usePageScroll();
  const lurp = clampedInversedLerp(0, ANIMATION_END_SCROLL, absoluteScroll);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 250);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {isClient && <StyledCatAnimation visible={visible} lurp={lurp} />}
      {isClient && <StyledDogAnimation visible={visible} lurp={lurp} />}
    </>
  );
};

export default PetAnimation;
